import styles from "./WhyChooseMbaCard.module.scss";
import updateImageDomain from "@/common/imageUrlReplace";
import clsx from "clsx";

const WhyChooseMbaCard = ({ data }) => {
    const { Icon, FrontText, BackText } = data;
    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <div className={styles.img_wrapper}>
                        <img
                            src={updateImageDomain(Icon)}
                            width={25}
                            height={25}
                            alt="icon"
                        />
                </div>
                <div className={styles.box_desc_container}>
                    <div className={styles.content_wrapper}>
                        <div className={styles.current_text}>
                            <h3
                                className={clsx(styles.desc_text, "lining-nums")}
                                dangerouslySetInnerHTML={{
                                    __html: FrontText
                                }}
                            />
                            <img src="/_a/images/Link.svg" width={40} height={40} alt="link logo" />
                        </div>
                        <div 
                            className={clsx(styles.hidden_text, "lining-nums")}
                            dangerouslySetInnerHTML={{
                                __html: BackText
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhyChooseMbaCard